// ⬅ IMPORTANT: le bon import
import { EditorView } from '@codemirror/view';

export const customScrollbar = EditorView.theme({
  /* L'éditeur occupe 100% de la hauteur disponible */
  '&': { height: '100%' },            // .cm-editor

  /* Le scroller interne gère le débordement */
  '.cm-scroller': {
    overflow: 'auto',                  // ⬅ le scroll se fait ici
    minHeight: 0,                      // ⬅ empêche l’étirement vertical
    scrollbarWidth: 'thin',
    scrollbarColor: '#888 #f0f0f0',
  },

  /* Petites barres jolies */
  '.cm-scroller::-webkit-scrollbar': { width: '8px', height: '8px' },
  '.cm-scroller::-webkit-scrollbar-track': { background: '#f0f0f0' },
  '.cm-scroller::-webkit-scrollbar-thumb': {
    backgroundColor: '#888', borderRadius: '4px', border: '1px solid #f0f0f0',
  },
  '.cm-scroller::-webkit-scrollbar-thumb:hover': { backgroundColor: '#555' },
});
